import {
  Card,
  Container,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Skeleton,
  Button,
} from "@mui/material";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import { useOrgConfig } from "~/providers/OrgConfigProvider";
import { useState } from "react";

import Help from "~/components/common/Help";
import ServiceRow, { emptyService, ServiceDialog } from "./ServiceRow";
import { compact, sortBy } from "lodash";

const serviceColumns = [
  { label: "Service", width: "40%", help: "A task that can be selected when scheduling a visit of a given visit type, e.g. Wound Care." },
  { label: "Duration", width: "15%" },
  { label: "Description", width: "35%" },
  { label: "Active", width: "10%" },
];

const TabServices = () => {
  const { services, loading } = useOrgConfig();

  const [createDialogOpen, setCreateDialogOpen] = useState(false)
  const serviceList = sortBy(compact(Object.values(services)), "name");

  return (
    <Container maxWidth={false} sx={{ mt: 4, mb: 4 }}>
      <Card sx={{ height: "100%" }}>
        <TableContainer>
          <Table sx={{ tableLayout: 'fixed' }}>
            <TableHead>
              <TableRow>
                {serviceColumns.map(({ label, width, help }) => (
                  <TableCell key={label} sx={{ width }}>
                    {label}
                    {help && <Help text={help} />}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {loading ? (
                <>
                  <RowSkeleton />
                  <RowSkeleton />
                  <RowSkeleton />
                </>
              ) : serviceList.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={serviceColumns.length} sx={{ textAlign: "center" }}>
                    No services found
                  </TableCell>
                </TableRow>
              ) : (
                serviceList.map((service) => <ServiceRow key={service.id} service={service} />)
              )}
              <TableRow>
                <TableCell colSpan={serviceColumns.length}>
                  <Button
                    onClick={() => setCreateDialogOpen(true)}
                    size="small"
                    startIcon={<AddCircleOutlineIcon fontSize="small" />}
                  >
                    Add New Service
                  </Button>
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
      </Card>

      {createDialogOpen && <ServiceDialog
        service={emptyService}
        onClose={() => setCreateDialogOpen(false)}
      />}
    </Container>
  );
};

export default TabServices;

const RowSkeleton = () => (
  <TableRow>
    {serviceColumns.map(({ label }) => (
      <TableCell key={label}>
        <Skeleton width="100%" />
      </TableCell>
    ))}
  </TableRow>
);
